export enum SELECT_GUEST_MODAL_ACTION {
  SELECT = 'select',
  DELETE = 'delete',
  ADD_NEW_GUEST = 'add_new_guest',
  PRINT = 'print',
  CANCEL = 'cancel',
  EDIT = 'edit',
}
